import { ReactElement, ReactNode } from "react";

import { useFloatingHover } from "../../hooks/useFloatingHover.ts";

interface FloatingToolProps {
  children?: ReactNode;
  className?: string;
  delay?: number;
  disabled?: boolean;
  icon: ReactNode;
  onClose?: () => void;
  onOpen?: () => void;
}

export const FloatingTool = ({
  children,
  className = "",
  delay = 500,
  disabled = false,
  icon,
  onClose,
  onOpen,
}: FloatingToolProps): ReactElement => {
  const {
    handleMenuMouseEnter,
    handleMenuMouseLeave,
    handleMouseEnter,
    handleMouseLeave,
    isOpen,
  } = useFloatingHover({ delay, onClose, onOpen });

  return (
    <div className={`relative ${className}`}>
      <div
        className={`flex h-6 w-6 cursor-pointer items-center justify-center ${
          disabled ? "cursor-not-allowed opacity-50" : ""
        }`}
        onMouseEnter={disabled ? undefined : handleMouseEnter}
        onMouseLeave={disabled ? undefined : handleMouseLeave}
      >
        {icon}
      </div>

      {isOpen && children && (
        <div
          className="absolute left-full top-0 ml-4"
          onMouseEnter={handleMenuMouseEnter}
          onMouseLeave={handleMenuMouseLeave}
        >
          {children}
        </div>
      )}
    </div>
  );
};
